<div class="container flex flex-col flex-1 min-h-0 overflow-hidden">
  <!-- <mat-form-field
    class="fuse-mat-dense fuse-mat-rounded min-w-64 w-80 my-1 mb-3"
    subscriptSizing="dynamic"
  >
    <mat-icon
      class="icon-size-5"
      matPrefix
      svgIcon="heroicons_solid:magnifying-glass"
    ></mat-icon>
    <input
      matInput
      placeholder="Buscar"
      autocomplete="off"
      (input)="onSearchInput($event)"
    />
  </mat-form-field> -->

  <!-- Header -->
  <div class="overflow-auto flex-1 sticky top-0 z-10">
    <table
      class="min-w-500 overflow-y-visible mat-elevation-z w-140"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="onSortChange($event)"
    >
      <!-- Cliente -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">
          Nombre
        </th>
        <td mat-cell *matCellDef="let row" class="text-left text-uppercase">
          <span class="table-text-code">{{
            row?.soldTo.externalKeys.code
          }}</span
          ><br />{{ row?.soldTo.name }}
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="sticky top-0 z-10  bg-white dark:bg-gray-900"
      ></tr>

      <!-- Fila Principal -->
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="border-b"
      ></tr>
    </table>
  </div>
  <div
    *ngIf="this.dataSource?.data?.length === 0"
    class="border-t p-8 text-center text-1xl sm:p-10"
  >
    Lo sentimos, no hay registros para mostrar.
  </div>
</div>
